import React from 'react';
import { styled } from "styled-components";

const PrimaryBtn = styled.button`
  border: 0px solid;
  border-radius: 10px;
  background: var(--Purple-Primary, #9738FF);
  height: 46px;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 16px;

  color: var(--White-FF, #FFF);
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;

  /* Body/Body L Bold */
  
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */

  cursor: pointer;
  width: max-content;
`;

const DefaultBtn = styled.button`
  border: 0px solid;
  border-radius: 10px;
  background: #F3ECFF;
  height: 46px;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 16px;

  color: #9738FF;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;

  /* Body/Body L Bold */
  
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */

  cursor: pointer;
  width: max-content;
`;

const DisabledBtn = styled.button`
  border: 0px solid;
  border-radius: 10px;
  background: #F5F5F5;
  height: 46px;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 16px;

  color: #6F6F6F;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;

  /* Body/Body L Bold */
  
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */

  cursor: pointer;
  width: max-content;
`;

const Button = ({ title, onClick, className, disabled }) => {
  const StyledButton = className === 'primaryBtn' ? PrimaryBtn : DefaultBtn;

  return disabled ? <DisabledBtn>{title}</DisabledBtn> : <StyledButton onClick={onClick}>{title}</StyledButton>;
}

export default Button;
